import { useEffect } from 'react'
import useGlobalThemeStore from '@/store/globalTheme'
import microApp from '@micro-zoe/micro-app'

const useTheme = () => {
    const { colorPrimary, setColorPrimary } = useGlobalThemeStore()
    const theme = {
        colorPrimary: colorPrimary,
        colorLink: colorPrimary,
        colorText: '#031F47',
        borderRadius: 2,
        colorBorder: '#F0F0F0'
    }
    // todo: 从接口获取主题颜色等外观配置
    useEffect(() => {
        const dataListener = (data: any) => {
            if (data?.theme?.colorPrimary) {
                setColorPrimary(data.theme.colorPrimary)
            }
        }
        if (window.microApp) {
            window.microApp.addDataListener(dataListener, true)
        }
        return () => {
            if (window.microApp) {
                window.microApp.removeDataListener(dataListener)
            }
        }
    }, [setColorPrimary])

    // 设置微应用主题颜色
    const setMicroTheme = (colorPrimary) => {
        microApp.setData('authCommon', {
            product: 'iKG',
            theme: {
                colorPrimary: colorPrimary,
                colorLink: colorPrimary,
            }
        })
    }

    return { theme }
}

export default useTheme